import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import NeuralBackground from './components/NeuralBackground';
import DemoModal from './components/DemoModal';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Benefits from './components/Benefits';
import UseCases from './components/UseCases';
import Testimonials from './components/Testimonials';
import Integrations from './components/Integrations';
import Pricing from './components/Pricing';
import Blog from './components/Blog';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import TermsOfService from './components/pages/TermsOfService';
import Security from './components/pages/Security';
import GDPR from './components/pages/GDPR';
import CookiePolicy from './components/pages/CookiePolicy';
import Product from './components/pages/Product';
import CookieBanner from './components/CookieBanner';

const PAYPAL_CLIENT_ID = 'AT63qJnU-XwLoaDzYfFMcXfT9yn8BkwJnvEKz-uEB_4ZmVrU-TdCf3FZKHBqcvnmmPX6FZv5dfDUch_l';

/* Scroll to top on route change */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
};

/* Home page (single-page scrollable) */
const Home = () => {
  const [demoOpen, setDemoOpen] = useState(false);
  return (
    <div className="bg-dark text-white min-h-screen relative">
      <NeuralBackground />
      <Navbar onDemo={() => setDemoOpen(true)} />
      <main>
        <Hero onDemo={() => setDemoOpen(true)} />
        <AboutUs />
        <Features />
        <HowItWorks />
        <Benefits />
        <UseCases />
        <Testimonials />
        <Integrations />
        <Pricing onDemo={() => setDemoOpen(true)} />
        <Blog />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <DemoModal isOpen={demoOpen} onClose={() => setDemoOpen(false)} />
    </div>
  );
};

function App() {
  return (
    <PayPalScriptProvider options={{ 'client-id': PAYPAL_CLIENT_ID, currency: 'USD' }}>
      <BrowserRouter>
        <ScrollToTop />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/security" element={<Security />} />
          <Route path="/gdpr" element={<GDPR />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/product" element={<Product />} />
        </Routes>
      </BrowserRouter>
    </PayPalScriptProvider>
  );
}

export default App;
